import { Pencil } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import type { WhatsAppConfig } from '@/types';

interface WhatsAppConfigListProps {
  configs: WhatsAppConfig[];
  onEdit: (config: WhatsAppConfig) => void;
}

export function WhatsAppConfigList({ configs, onEdit }: WhatsAppConfigListProps) {
  if (configs.length === 0) {
    return (
      <div className="text-center py-8 text-muted-foreground">
        No WhatsApp configurations found.
      </div>
    );
  }

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Service ID</TableHead>
          <TableHead>Phone Number ID</TableHead>
          <TableHead>API URL</TableHead>
          <TableHead className="text-right">Actions</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {configs.map((config) => (
          <TableRow key={config.id ?? config.serviceId}>
            <TableCell className="font-medium">{config.serviceId}</TableCell>
            <TableCell>{config.phoneNumberId}</TableCell>
            <TableCell className="max-w-[200px] truncate">{config.apiUrl}</TableCell>
            <TableCell className="text-right">
              <Button
                variant="ghost"
                size="icon"
                onClick={() => onEdit(config)}
                aria-label={`Edit ${config.serviceId}`}
              >
                <Pencil className="h-4 w-4" />
              </Button>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
